/** Whether the user has a completed face enrollment for attendance. */
export function hasFaceRegistered(user) {
  if (!user) return false;
  return Boolean(user.face_registered_at && user.face_recognition_enabled);
}

export function formatFaceRegisteredAt(user) {
  if (!user?.face_registered_at) return null;
  try {
    return new Date(user.face_registered_at).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return null;
  }
}
